import DailyLogComp from '../../components/dailyLog';

export default function DailyLogs({ isTimeTrack }) {
  return (
    <div className={`${isTimeTrack ? "app-container-with-time-track-at-bottom" : "app-container"}`}>
      <DailyLogComp />
    </div>
  );
}
